export const isBuilding = process.env.REACT_APP_IS_BUILDING === "true"